export const ImageFormats = ['image/jpg', 'image/jpeg', 'image/png'];